import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer170 } from './pages'

type TIdToPageMapWoofzOffer170 = Record<PageIdWoofzOffer170, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER1_70: TIdToPageMapWoofzOffer170 = {
  [PageIdWoofzOffer170.SUBSCRIPTIONS_OFFER1_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/subscriptions/SubscriptionsOffer170'
      ).then((m) => ({
        default: m.SubscriptionsOffer170,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/subscriptions/SubscriptionsOffer170'
      ),
  },
  [PageIdWoofzOffer170.CHAT_UPSELL_OFFER1_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer170.UPSELL_OFFER1_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer1_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer170.DOWNLOAD_OFFER1_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer170.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
